import enTranslationMessages from './compiled-lang/en.json';
import frTranslationMessages from './compiled-lang/fr.json';

export default {
  en: enTranslationMessages,
  fr: frTranslationMessages
};
